import { css } from 'styled-components'

// Utilities
import theme from './theme'

export const documentStyles = css`
  /** Inter Regular */
  @font-face {
    font-family: 'Inter';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/Inter-Regular.woff2'), url('/fonts/Inter-Regular.woff2');
  }

  /** Inter Medium */
  @font-face {
    font-family: 'Inter';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/Inter-Medium.woff2'), url('/fonts/Inter-Medium.woff2');
  }

  /** Inter Italic */
  @font-face {
    font-family: 'Inter';
    font-weight: 400;
    font-style: italic;
    font-display: swap;
    src: url('/blog/fonts/Inter-Italic.woff2'), url('/fonts/Inter-Italic.woff2');
  }

  /** Inter SemiBold */
  @font-face {
    font-family: 'Inter';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/Inter-SemiBold.woff2'), url('/fonts/Inter-SemiBold.woff2');
  }

  /** Inter SemiBold Italic */
  @font-face {
    font-family: 'Inter';
    font-weight: 600;
    font-style: italic;
    font-display: swap;
    src: url('/blog/fonts/Inter-SemiBoldItalic.woff2'), url('/fonts/Inter-SemiBoldItalic.woff2');
  }

  /** Inter Bold */
  @font-face {
    font-family: 'Inter';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/Inter-Bold.woff2'), url('/fonts/Inter-Bold.woff2');
  }

  /** Inter Bold Italic */
  @font-face {
    font-family: 'Inter';
    font-weight: 700;
    font-style: italic;
    font-display: swap;
    src: url('/blog/fonts/Inter-BoldItalic.woff2'), url('/fonts/Inter-BoldItalic.woff2');
  }

  /** Barlow Bold */
  @font-face {
    font-family: 'Barlow';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/Barlow-Bold.woff2'), url('/fonts/Barlow-Bold.woff2');
  }

  @font-face {
    font-family: 'JetBrainsMono';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/blog/fonts/JetBrainsMono-Regular.woff2'), url('/fonts/JetBrainsMono-Regular.woff2');
  }
  html {
    line-height: 1.15;
    font-size: 16px;
    box-sizing: border-box;
    background: ${theme.colors.white};
  }

  body {
    margin: 0;
    font-family: ${theme.fonts.text};
    font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    text-decoration-skip-ink: auto;
    text-decoration-skip: ink;
    background: white;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  h1,
  h2,
  h3 {
    font-family: ${theme.fonts.display};
    font-weight: 700;
  }

  a {
    color: currentColor;
    text-decoration: none;
    transition: color 100ms ease;
  }

  ::selection {
    background: ${theme.primary};
    color: white;
  }
  
  code, kbd, samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  button, input, optgroup, select, textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button, select {
    text-transform: none;
  }

  button, input {
    overflow: visible;
  }

  #nprogress .bar {
    height: 3px;
  }
`
